module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-164.c02f595d.svg";